// import React, { useState, useEffect, useRef } from 'react';
// import {
//   Card,
//   Row,
//   Col,
//   CardTitle,
//   CardBody,
//   Button,
//   Form,
//   FormGroup,
//   Label,
//   Input,
//   FormText,
//   NavLink,
//   Modal,
//   ModalHeader,
//   ModalBody,
//   ModalFooter,
// } from 'reactstrap';

// import { useNavigate, useLocation } from 'react-router-dom';
// import { apiService } from '../../constants/ApiService';
// import { BlobProvider, pdf, PDFDownloadLink } from '@react-pdf/renderer';
// import Autocomplete from '@mui/material/Autocomplete';
// import TextField from '@mui/material/TextField';
// import { useSelector } from 'react-redux';
// import PdfView from './PdfView';
// import { formatDate } from '../../constants/DateFormatter';

// const TcIssueSaveScreen = ({ systemData }) => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const sessionData = useSelector((state) => state.sessionState);
//   const [AdmissionNo, setAdmissionNo] = useState('');
//   const [showFeeSlabDetails, setShowFeeSlabDetails] = useState(false);
//   const [AutoCompleteValue, setAutoCompleteValue] = useState(null);
//   const [studRecords, setStudRecords] = useState([]);
//   const [resultDetailList, setResultDetailList] = useState([]);
//   const [modal, setModal] = useState(false);
//   const toggle = () => setModal(!modal);

//   const [errorMessage, setErrorMessage] = useState({});
//   const [feeBalanceDetails, setFeeBalanceDetails] = useState({});
//   const [AdmissionData, setAdmissionData] = useState({});

//   const [Tc_Issue_Master_DetailData, setTc_Issue_Master_DetailData] = useState({
//     id: 0,
//     tc_no_manual: '',
//     //  entry_date_time: '',
//     issue_date: new Date()
//       .toLocaleDateString('en-CA', { timeZone: 'Asia/Kolkata' })
//       .split('T')[0],
//     // photo_image: '',
//     // adm_sch_id: 0,
//     admit_no: '',
//     // sname: '',
//     // sex_mf: '',
//     // d_o_b: '',
//     // adm_date: '',
//     // f_name: '',
//     // m_name: '',
//     tc_for_current: '',
//     tc_for_end: '',
//     // curr_class: '',
//     // curr_class_in_roman: '',
//     // curr_class_in_word: '',
//     // promoted_class: '',
//     // promoted_class_in_roman: '',
//     // promoted_class_in_word: '',
//     // date_numric: 0,
//     // month_no: 0,
//     // year_no: 0,
//     // from_year: '',
//     // to_year: '',
//     possible_attend_days: '',
//     attendance_days: '',
//     leave_taken_days: '',
//     result_detail: '',
//     promot_yn: '',
//     certificate_type: '',
//     file_no_1: '',
//     file_no_2: '',
//     last_attended_date: '',
//     withdraw_date: '',
//     narr_remark: '',
//     session_year: sessionData.session_year,
//     sys_remark: '',
//     fee_remark: '',
//     tc_no_auto_id: 0,
//     fee_group_id: 0,
//     slabMstId: 0,
//   });

//   const [Multi_Purpose_Type_MasterData, setMulti_Purpose_Type_MasterData] =
//     useState({
//       multi_purpose_flag: '',
//       multi_purpose_code: '',
//       multi_purpose_type: '',
//       multi_purpose_remark: '',
//     });

//   const GetSingleAdmissionRecord = async (search = '') => {
//     try {
//       let config = {
//         headers: {
//           'Content-Type': 'application/json',
//           accept: 'application/json',
//         },
//       };

//       const apiUrl = `api/Admission/GetSingleAdmissionRecord?search=${search}`;

//       const response = await apiService.get(apiUrl, config);

//       if (response.response && response.response.data.errors) {
//         alert(response.response?.data?.errors);
//       }

//       if (response.status === true) {
//         let respData = response.admissionDetail;
//         setAdmissionData(respData);
//         setAutoCompleteValue(respData);
//       } else {
//         alert('No student found for this admission no.');
//       }
//     } catch (error) {
//       console.log(error);
//       alert('Something went wrong!!');
//     }
//   };

//   const GetAdmission = async (search) => {
//     try {
//       // If search is not empty, get all records and then slice the last 10
//       if (search !== '') {
//         const response = await apiService.get(
//           `api/Admission/GetAdmission?search=${search}`,
//         );

//         if (response.response && response.response.data.errors) {
//           alert(response.response?.data?.errors);
//         }
//         if (response.status === true) {
//           let admissionData = response.data;

//           setStudRecords(admissionData);
//           // console.log(admissionData,"admission Data updated")
//           // console.log(Tc_Issue_Master_DetailData?.admit_no,"admission no")
//         } else {
//           alert(response.message);
//         }
//       }
//     } catch (error) {
//       console.log(error);
//       alert('Something went wrong!!');
//     }
//   };

//   useEffect(() => {
//     Get_All_Multi_Purpose_Type_Master();

//     if (location.state) {
//       setTc_Issue_Master_DetailData(location.state);
//       setAdmissionNo(location.state.admit_no);
//       GetSingleAdmissionRecord(location.state.admit_no);

//       //GetStudentFeeDetails(location.state.admit_no, location.state.month_name, location.state.month_no);
//     }
//   }, [location.state]);

//   useEffect(() => {
//     if (
//       Tc_Issue_Master_DetailData?.net_amt ===
//       feeBalanceDetails?.current_month_fee_amt
//     ) {
//       setShowFeeSlabDetails(true);
//     } else {
//       setShowFeeSlabDetails(false);
//     }
//   }, [Tc_Issue_Master_DetailData, feeBalanceDetails]);

//   // useEffect(() => {
//   //   CalculateFees();
//   // }, [Tc_Issue_Master_DetailData?.amt_rec, Tc_Issue_Master_DetailData?.late_fee_amt, Tc_Issue_Master_DetailData?.dis_amt]);

//   const onHandleBackParty = () => {
//     navigate('/Tc_Issue_Master_Detail_Search_Screen');
//   };

//   const onInputChange = (event, newInputValue) => {
//     GetAdmission(newInputValue);
//     setTc_Issue_Master_DetailData((prevData) => ({
//       ...prevData,
//       admit_no: newInputValue,
//     }));
//     //setStudRecords([]);
//   };

//   const calculateLeaves = () => {};

//   const onChangeHandle = (event) => {
//     const { name, value } = event.target;

//     if (name === 'possible_attend_days') {
//       let total = parseFloat(value) || 0;
//       let attend = parseFloat(Tc_Issue_Master_DetailData.attendance_days) || 0;

//       let leaves = total - attend;
//       setTc_Issue_Master_DetailData((prevData) => ({
//         ...prevData,
//         [name]: String(total),
//         attendance_days: String(attend),
//         leave_taken_days: String(leaves),
//       }));
//     } else if (name === 'attendance_days') {
//       let total =
//         parseFloat(Tc_Issue_Master_DetailData.possible_attend_days) || 0;
//       let attend = parseFloat(value) || 0;

//       let leaves = total - attend;
//       setTc_Issue_Master_DetailData((prevData) => ({
//         ...prevData,
//         possible_attend_days: String(total),
//         [name]: String(attend),
//         leave_taken_days: String(leaves),
//       }));
//     }

//     setTc_Issue_Master_DetailData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };

//   const onChangeHandle1 = (e) => {
//     const { name, value } = e.target;
//     setMulti_Purpose_Type_MasterData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));

//     setErrorMessage((prevErrors) => ({
//       ...prevErrors,
//       [name]: '', // Clear the previous error when the user starts typing
//     }));
//   };
//   const validateInputs1 = () => {
//     const errors = {};
//     if (!Multi_Purpose_Type_MasterData.multi_purpose_type) {
//       errors.multi_purpose_type = 'multi_purpose_type is required';
//     }

//     return errors;
//   };

//   const save_multi_purpose_master = async () => {
//     try {
//       const errors = validateInputs1();
//       if (Object.keys(errors).length > 0) {
//         setErrorMessage(errors);
//         return;
//       }

//       let config = {
//         headers: {
//           Accept: 'application/json',
//           'Content-Type': 'application/json',
//         },
//       };
//       const data = JSON.stringify(Multi_Purpose_Type_MasterData);

//       //
//       let response;

//       if (
//         Multi_Purpose_Type_MasterData.id === '0' ||
//         Multi_Purpose_Type_MasterData.id === 0
//       ) {
//         response = await apiService.put(
//           `api/Multi_Purpose_Type_Master/UpdateMulti_Purpose_Type_Master?id=${Multi_Purpose_Type_MasterData.id}`,
//           data,
//           config,
//         );
//       } else {
//         response = await apiService.post(
//           'api/Multi_Purpose_Type_Master/AddMulti_Purpose_Type_Master',
//           data,
//           config,
//         );
//       }
//       if (response.status === true) {
//         alert(response.message);
//         setModal(!modal);
//         setMulti_Purpose_Type_MasterData({
//           multi_purpose_flag: '',
//           multi_purpose_code: '',
//           multi_purpose_type: '',
//           multi_purpose_remark: '',
//         });
//         Get_All_Multi_Purpose_Type_Master();
//       } else {
//         alert(response.message);
//       }
//     } catch (error) {
//       console.log(error);
//       alert('Something went wrong"');
//     }
//   };

//   const GetStudentFeeDetails = async (adm_no, month_name, month_no) => {
//     const errors = {};
//     try {
//       if (!month_name) {
//         errors.month_name = 'No Month is selected';
//         setErrorMessage(errors);
//         setAutoCompleteValue(null);
//         return;
//       }

//       if (!month_no) {
//         errors.month_no = 'No Month is selected';
//         setErrorMessage(errors);
//         setAutoCompleteValue(null);
//         return;
//       }

//       const response = await apiService.get(
//         `api/FeeReciept/GetStudentFeeDetails?adm_no=${adm_no}&month_name=${month_name}&month_no=${month_no}&session=${sessionData.session_year}`,
//       );

//       if (response.response && response.response.data.errors) {
//         alert(response.response?.data?.errors);
//       }

//       if (response.status === true) {
//         //alert(response.message);
//         setFeeBalanceDetails(response);
//         setAdmissionData(response.studentDetails);
//         setStudRecords([response.studentDetails]);

//         setAutoCompleteValue(response.studentDetails);
//       } else {
//         alert(response.message);
//       }
//     } catch (error) {
//       console.log(error);
//       alert('SomeThing went wrong');
//     }
//   };

//   const validateInputs = () => {
//     const errors = {};

//     if (!Tc_Issue_Master_DetailData?.admit_no) {
//       errors.admit_no = 'Adm no is required';
//     }

//     if (!Tc_Issue_Master_DetailData?.from_year) {
//       errors.from_year = 'From year is required';
//     }
//     if (!Tc_Issue_Master_DetailData?.to_year) {
//       errors.to_year = 'To year is required';
//     }
//     if (!Tc_Issue_Master_DetailData?.possible_attend_days) {
//       errors.possible_attend_days = 'Possible attended days is required';
//     }
//     // if (!Tc_Issue_Master_DetailData?.attendance_days) {
//     //   errors.attendance_days = 'attendance_days is required';
//     // }
//     if (!Tc_Issue_Master_DetailData?.leave_taken_days) {
//       errors.leave_taken_days = 'Leave taken days is required';
//     }
//     if (!Tc_Issue_Master_DetailData?.result_detail) {
//       errors.result_detail = 'Result detail is required';
//     }
//     if (!Tc_Issue_Master_DetailData?.promot_yn) {
//       errors.promot_yn = 'Promote status is required';
//     }
//     if (!Tc_Issue_Master_DetailData?.certificate_type) {
//       errors.certificate_type = 'Certificate type is required';
//     }

//     if (!Tc_Issue_Master_DetailData?.last_attended_date) {
//       errors.last_attended_date = 'Last attended date is required';
//     }
//     if (!Tc_Issue_Master_DetailData?.withdraw_date) {
//       errors.withdraw_date = 'Withdraw date is required';
//     }
//     if (!Tc_Issue_Master_DetailData?.sys_remark) {
//       errors.sys_remark = 'Remark is required';
//     }

//     if (!Tc_Issue_Master_DetailData?.fee_remark) {
//       errors.fee_remark = 'Fee remark is required';
//     }
//     return errors;
//   };

//   const SaveFunction = async () => {
//     try {
//       const errors = validateInputs();
//       if (Object.keys(errors).length > 0) {
//         setErrorMessage(errors);
//         console.log(errors);
//         return;
//       }

//       Tc_Issue_Master_DetailData.admit_no = AdmissionNo;

//       let config = {
//         headers: {
//           Accept: 'application/json',
//           'Content-Type': 'application/json',
//         },
//       };

//       let response;

//       if (Tc_Issue_Master_DetailData?.id === 0) {
//         response = await apiService.post(
//           'api/TcIssueMasterDetail/AddTc_Issue_Master_Detail',
//           Tc_Issue_Master_DetailData,
//           config,
//         );
//       } else {
//         response = await apiService.put(
//           `api/TcIssueMasterDetail/UpdateTc_Issue_Master_Detail?id=${Tc_Issue_Master_DetailData?.id}`,
//           Tc_Issue_Master_DetailData,
//           config,
//         );
//       }

//       if (response.status === true) {
//         alert(response.message);
//         setTc_Issue_Master_DetailData(response.tcIssueMasterDetail);
//         console.log(response.tcIssueMasterDetail);
//       } else {
//         alert(response.message);
//       }
//     } catch (error) {
//       console.log(error);
//       alert('Something went wrong');
//     }
//   };

//   const onHandleDelete = async () => {
//     const isDeleteConfirmed = window.confirm(
//       'Are you sure you want to delete this item?',
//     );
//     if (isDeleteConfirmed) {
//       try {
//         let config = {
//           headers: {
//             'Content-Type': 'application/json',
//             accept: 'application/json',
//           },
//         };

//         const response = await apiService.delete(
//           `api/TcIssueMasterDetail/DeleteTc_Issue_Master_Detail?id=${location.state?.id}`,
//           config,
//         );

//         if (response.response && response.response.data.errors) {
//           alert(response.response?.data?.errors);
//         }

//         if (response.status === true) {
//           alert(response.message);
//         } else {
//           alert(response.message);
//         }
//       } catch (error) {
//         console.log(error);
//         alert('Something went wrong');
//       }
//     } else {
//       console.log('Deletion canceled.');
//     }
//   };

//   const CertificateList = [
//     { label: '-Select-', value: '' },
//     { label: 'Original', value: 'ORIGINAL' },
//     { label: 'Duplicate', value: 'DUPLICATE' },
//     { label: 'Triplicate', value: 'TRIPLICATE' },
//   ];
//   const ynList = [
//     { label: '-Select-', value: '' },
//     { label: 'Yes', value: 'YES' },
//     { label: 'No', value: 'NO' },
//   ];

//   const Get_All_Multi_Purpose_Type_Master = async () => {
//     try {
//       let config = {
//         headers: {
//           'Content-Type': 'application/json', // Important for file upload//s
//           accept: 'application/json',
//         },
//       };
//       const response = await apiService.get(
//         `api/Multi_Purpose_Type_Master/GetMulti_Purpose_Type_Master?filter=Result_Detail`,
//         config,
//       );
//       if (response.response && response.response.data.errors) {
//         alert(response.response?.data?.errors);
//       }
//       if (response.status === true) {
//         setResultDetailList(response.data);
//       } else {
//         alert(response.message);
//       }
//     } catch (error) {
//       console.log(error);
//       alert('SomeThing went wrong!!');
//     }
//   };

//   const onHandleMultipleValue = (param) => {
//     setModal(!modal);
//     setMulti_Purpose_Type_MasterData((prevData) => ({
//       ...prevData,
//       multi_purpose_flag: param,
//     }));
//   };

//   return (
//     <>
//       <div className='container'>
//         <div className='bg-white pd-5 card-box mb-5 toolbar-row sticky-top border text-right mb-2'>
//           <Button color='success' onClick={SaveFunction}>
//             <i className='bi bi-check-circle' /> Save
//           </Button>
//           &nbsp;
//           <Button
//             className='btn btn-warning'
//             onClick={() => onHandleBackParty()}
//             //to="/Fee_Reciept_Master_Search"
//           >
//             <i className='bi bi-arrow-left' /> Back
//           </Button>
//           {Tc_Issue_Master_DetailData?.id !== 0 &&
//             AdmissionData &&
//             Tc_Issue_Master_DetailData &&
//             systemData && (
//               <>
//                 &nbsp;
//                 <BlobProvider
//                   document={
//                     <PdfView
//                       admission_Data={AdmissionData}
//                       tc_Issue_Master_Data={Tc_Issue_Master_DetailData}
//                       schoolData={systemData}
//                     />
//                   }
//                 >
//                   {({ url }) => {
//                     console.log('PDF URL:', url); // Log the URL to ensure it's generated
//                     return (
//                       <button
//                         className='btn btn-info'
//                         onClick={() => {
//                           if (url) {
//                             // Open the PDF in a new tab
//                             window.open(url, '_blank');
//                           }
//                         }}
//                       >
//                         <i className='bi bi-printer' /> Print TC
//                       </button>
//                     );
//                   }}
//                 </BlobProvider>
//                 &nbsp;
//                 <Button
//                   color='danger'
//                   size='bg'
//                   onClick={() => onHandleDelete()}
//                 >
//                   Delete
//                 </Button>
//               </>
//             )}
//           {/* <PDFDownloadLink
//           className='btn btn-info'
//           document={
//             <PdfView
//               AdmissionData={AdmissionData}
//               tc_Issue_Master_Data={Tc_Issue_Master_DetailData}
//             />
//           }
//           fileName='fee_acceptance'
//         >
//           {({ blob, url, loading, error }) =>
//             loading ? 'Loading document...' : <><i className="bi bi-printer" /> Print</>
//           }
//         </PDFDownloadLink> */}
//         </div>
//         <Row>
//           <Col className='col-sm-7'>
//             <Card className='card-box height-100-p pd-20 mb-20'>
//               <CardTitle
//                 tag='h6'
//                 className='border-bottom p-3 mb-0 d-flex align-items-center justify-content-between'
//               >
//                 <div className='d-flex align-items-center'>
//                   <i className='bi bi-card-text mr-2'></i>
//                   TC Issue Details
//                 </div>
//               </CardTitle>

//               <CardBody>
//                 <Form>
//                   <table className='table table-borderless'>
//                     <tbody>
//                       <tr>
//                         <td>
//                           <h6>Admission No. </h6>
//                         </td>
//                         <td>
//                           <Autocomplete
//                             //className='form-control'
//                             name='admit_no'
//                             id='admit_no'
//                             options={studRecords}
//                             value={AutoCompleteValue}
//                             getOptionLabel={(option) =>
//                               option.admit_no +
//                               ' - ' +
//                               option.stud_name +
//                               ' - ' +
//                               option.f_name
//                             }
//                             onChange={(event, newValue) => {
//                               if (newValue) {
//                                 setTc_Issue_Master_DetailData((prevData) => ({
//                                   ...prevData,
//                                   admit_no: newValue.admit_no,
//                                   tc_issue_yn: newValue.tc_issue_yn,
//                                 }));
//                                 setAdmissionData(newValue);
//                                 setAdmissionNo(newValue.admit_no);
//                                 setAutoCompleteValue(newValue);
//                                 //GetStudentFeeDetails(newValue.admit_no, "April", 1);
//                               } else {
//                                 setTc_Issue_Master_DetailData((prevData) => ({
//                                   ...prevData,
//                                   admit_no: '', // Clear selection
//                                 }));
//                               }
//                             }}
//                             //onChange={(e)=>{onChangeHandle(e)}}
//                             onInputChange={onInputChange}
//                             // onInputChange={(event, newInputValue) => {
//                             //   GetAdmission(newInputValue)
//                             //   setTc_Issue_Master_DetailData((prevData) => ({
//                             //     ...prevData,
//                             //     admit_no: newInputValue,
//                             //   }))
//                             // }}
//                             openOnFocus={true}
//                             renderInput={(params) => (
//                               <TextField
//                                 sx={{
//                                   '& .MuiInputBase-root': {
//                                     height: '36px', // Adjust height
//                                     fontSize: '14px', // Match Bootstrap
//                                     borderRadius: '4px', // Match Bootstrap
//                                   },
//                                   '& .MuiOutlinedInput-input': {
//                                     padding: '8px', // Reduce padding
//                                   },
//                                 }}
//                                 {...params}
//                                 placeholder='Search Adm.no., Name, Father Name,etc'
//                                 variant='outlined'
//                               />
//                             )}
//                           />

//                           {/* <Input
//                           className='form-control'
//                           onChange={(e)=>{onChangeHandle(e)}}
//                           id='admitno'
//                           name='admitno'
//                           //value={Tc_Issue_Master_DetailData?.admit_no}
//                           type='text'
//                         /> */}
//                           {errorMessage.admit_no && (
//                             <FormText color='danger'>
//                               {errorMessage.admit_no}
//                             </FormText>
//                           )}
//                         </td>
//                       </tr>

//                       <tr>
//                         <td>
//                           <h6 for='tc_issue_yn'>TC Issued (Yes/No)</h6>
//                         </td>
//                         <td>
//                           <Input
//                             id='tc_issue_yn'
//                             name='tc_issue_yn'
//                             value={AdmissionData?.admission?.tc_issue_yn}
//                             onChange={(e) => {
//                               onChangeHandle(e);
//                             }}
//                             defaultValue={'NO'}
//                             type='select'
//                           >
//                             {ynList.map((option) => (
//                               <option key={option.value} value={option.value}>
//                                 {option.label}
//                               </option>
//                             ))}
//                           </Input>
//                           {errorMessage.tc_issue_yn && (
//                             <FormText color='danger'>
//                               {errorMessage.tc_issue_yn}
//                             </FormText>
//                           )}
//                         </td>
//                       </tr>
//                       <tr>
//                         <td>
//                           <h6 for='issue_date'>TC Issue Date</h6>
//                         </td>
//                         <td>
//                           <Input
//                             id='issue_date'
//                             name='issue_date'
//                             value={
//                               typeof Tc_Issue_Master_DetailData?.issue_date ===
//                                 'string' &&
//                               Tc_Issue_Master_DetailData?.issue_date.includes(
//                                 'T',
//                               )
//                                 ? Tc_Issue_Master_DetailData?.issue_date.split(
//                                     'T',
//                                   )[0]
//                                 : Tc_Issue_Master_DetailData?.issue_date
//                             }
//                             onChange={(e) => {
//                               onChangeHandle(e);
//                             }}
//                             type='date'
//                           />

//                           {errorMessage.issue_date && (
//                             <FormText color='danger'>
//                               {errorMessage.issue_date}
//                             </FormText>
//                           )}
//                         </td>
//                       </tr>
//                       <tr>
//                         <td>
//                           <h6 for='from_year'>Financial year from</h6>
//                         </td>
//                         <td>
//                           <Input
//                             id='from_year'
//                             name='from_year'
//                             value={Tc_Issue_Master_DetailData?.from_year}
//                             onChange={(e) => {
//                               onChangeHandle(e);
//                             }}
//                           />
//                           {errorMessage.from_year && (
//                             <FormText color='danger'>
//                               {errorMessage.from_year}
//                             </FormText>
//                           )}
//                         </td>
//                       </tr>
//                       <tr>
//                         <td>
//                           <h6 for='to_year'>Financial year To</h6>
//                         </td>
//                         <td>
//                           <Input
//                             id='to_year'
//                             name='to_year'
//                             value={Tc_Issue_Master_DetailData?.to_year}
//                             onChange={(e) => {
//                               onChangeHandle(e);
//                             }}
//                           />
//                           {errorMessage.to_year && (
//                             <FormText color='danger'>
//                               {errorMessage.to_year}
//                             </FormText>
//                           )}
//                         </td>
//                       </tr>

//                       <tr>
//                         <td>
//                           <h6 for='file_no_1'>File/Manual No</h6>
//                         </td>
//                         <td>
//                           <Input
//                             id='file_no_1'
//                             name='file_no_1'
//                             value={Tc_Issue_Master_DetailData?.file_no_1}
//                             onChange={(e) => {
//                               onChangeHandle(e);
//                             }}
//                           />
//                           {errorMessage.file_no_1 && (
//                             <FormText color='danger'>
//                               {errorMessage.file_no_1}
//                             </FormText>
//                           )}
//                         </td>
//                       </tr>
//                       <tr>
//                         <td>
//                           <h6 for='sys_remark'>Remark</h6>
//                         </td>
//                         <td>
//                           <Input
//                             id='sys_remark'
//                             name='sys_remark'
//                             value={Tc_Issue_Master_DetailData?.sys_remark}
//                             onChange={(e) => {
//                               onChangeHandle(e);
//                             }}
//                           />
//                           {errorMessage.sys_remark && (
//                             <FormText color='danger'>
//                               {errorMessage.sys_remark}
//                             </FormText>
//                           )}
//                         </td>
//                       </tr>
//                       <tr>
//                         <td>
//                           <h6 for='certificate_type'>Certificate Type</h6>
//                         </td>
//                         <td>
//                           <select
//                             className='custom-select'
//                             id='certificate_type'
//                             name='certificate_type'
//                             value={Tc_Issue_Master_DetailData?.certificate_type}
//                             onChange={(e) => {
//                               onChangeHandle(e);
//                             }}
//                           >
//                             {CertificateList.map((option) => (
//                               <option key={option.value} value={option.value}>
//                                 {option.label}
//                               </option>
//                             ))}
//                           </select>
//                           {errorMessage.certificate_type && (
//                             <FormText color='danger'>
//                               {errorMessage.certificate_type}
//                             </FormText>
//                           )}
//                         </td>
//                       </tr>
//                       <tr>
//                         <td>
//                           <h6 for='tc_for_end'>Tc After End Session</h6>
//                         </td>
//                         <td>
//                           <select
//                             className='custom-select'
//                             id='tc_for_end'
//                             name='tc_for_end'
//                             value={Tc_Issue_Master_DetailData?.tc_for_end}
//                             onChange={(e) => {
//                               onChangeHandle(e);
//                             }}
//                           >
//                             {ynList.map((option) => (
//                               <option key={option.value} value={option.value}>
//                                 {option.label}
//                               </option>
//                             ))}
//                           </select>
//                           {errorMessage.tc_for_end && (
//                             <FormText color='danger'>
//                               {errorMessage.tc_for_end}
//                             </FormText>
//                           )}
//                         </td>
//                       </tr>

//                       <tr>
//                         <td>
//                           <h6 for='possible_attend_days'>
//                             Possible Attendence
//                           </h6>
//                         </td>
//                         <td>
//                           <Input
//                             id='possible_attend_days'
//                             name='possible_attend_days'
//                             value={
//                               Tc_Issue_Master_DetailData?.possible_attend_days
//                             }
//                             onChange={(e) => {
//                               onChangeHandle(e);
//                             }}
//                           />
//                           {errorMessage.possible_attend_days && (
//                             <FormText color='danger'>
//                               {errorMessage.possible_attend_days}
//                             </FormText>
//                           )}
//                         </td>
//                       </tr>
//                       <tr>
//                         <td>
//                           <h6 for='attendance_days'>Actual Attendance</h6>
//                         </td>
//                         <td>
//                           <Input
//                             id='attendance_days'
//                             name='attendance_days'
//                             value={Tc_Issue_Master_DetailData?.attendance_days}
//                             onChange={(e) => {
//                               onChangeHandle(e);
//                             }}
//                           />
//                           {errorMessage.attendance_days && (
//                             <FormText color='danger'>
//                               {errorMessage.attendance_days}
//                             </FormText>
//                           )}
//                         </td>
//                       </tr>
//                       <tr>
//                         <td>
//                           <h6 for='leave_taken_days'>Total Leaves Taken</h6>
//                         </td>
//                         <td>
//                           <Input
//                             id='leave_taken_days'
//                             name='leave_taken_days'
//                             value={Tc_Issue_Master_DetailData?.leave_taken_days}
//                             onChange={(e) => {
//                               onChangeHandle(e);
//                             }}
//                             readOnly
//                           />
//                           {errorMessage.leave_taken_days && (
//                             <FormText color='danger'>
//                               {errorMessage.leave_taken_days}
//                             </FormText>
//                           )}
//                         </td>
//                       </tr>
//                       <tr>
//                         <td>
//                           <h6 for='result_detail'>
//                             Result{' '}
//                             <i
//                               className='bi bi-question-circle float-end text-primary'
//                               onClick={() =>
//                                 onHandleMultipleValue('Result_Detail')
//                               }
//                             />
//                           </h6>
//                         </td>
//                         <td>
//                           <Input
//                             id='result_detail'
//                             name='result_detail'
//                             type='select'
//                             value={Tc_Issue_Master_DetailData?.result_detail}
//                             onChange={(e) => {
//                               onChangeHandle(e);
//                             }}
//                           >
//                             <option value=''>-Select-</option>
//                             {resultDetailList.map((option) => (
//                               <option
//                                 key={option.multi_purpose_type}
//                                 value={option.multi_purpose_type}
//                               >
//                                 {option.multi_purpose_type}
//                               </option>
//                             ))}
//                           </Input>
//                           {errorMessage.result_detail && (
//                             <FormText color='danger'>
//                               {errorMessage.result_detail}
//                             </FormText>
//                           )}
//                         </td>
//                       </tr>

//                       <tr>
//                         <td>
//                           <h6 for='promot_yn'>Promoted (yes/no)</h6>
//                         </td>
//                         <td>
//                           <select
//                             className='custom-select'
//                             id='promot_yn'
//                             name='promot_yn'
//                             value={Tc_Issue_Master_DetailData?.promot_yn}
//                             onChange={(e) => {
//                               onChangeHandle(e);
//                             }}
//                           >
//                             {ynList.map((option) => (
//                               <option key={option.value} value={option.value}>
//                                 {option.label}
//                               </option>
//                             ))}
//                           </select>
//                           {errorMessage.promot_yn && (
//                             <FormText color='danger'>
//                               {errorMessage.promot_yn}
//                             </FormText>
//                           )}
//                         </td>
//                       </tr>
//                       <tr>
//                         <td>
//                           <h6 for='last_attended_date'>Last Attended Date</h6>
//                         </td>
//                         <td>
//                           <Input
//                             id='last_attended_date'
//                             name='last_attended_date'
//                             value={
//                               Tc_Issue_Master_DetailData?.last_attended_date.includes(
//                                 'T',
//                               )
//                                 ? Tc_Issue_Master_DetailData?.last_attended_date.split(
//                                     'T',
//                                   )[0]
//                                 : Tc_Issue_Master_DetailData?.last_attended_date
//                             }
//                             onChange={(e) => {
//                               onChangeHandle(e);
//                             }}
//                             type='date'
//                           />
//                           {errorMessage.last_attended_date && (
//                             <FormText color='danger'>
//                               {errorMessage.last_attended_date}
//                             </FormText>
//                           )}
//                         </td>
//                       </tr>
//                       <tr>
//                         <td>
//                           <h6 for='withdraw_date'>Withdrawal Date</h6>
//                         </td>
//                         <td>
//                           <Input
//                             id='withdraw_date'
//                             name='withdraw_date'
//                             value={
//                               Tc_Issue_Master_DetailData?.withdraw_date.includes(
//                                 'T',
//                               )
//                                 ? Tc_Issue_Master_DetailData?.withdraw_date.split(
//                                     'T',
//                                   )[0]
//                                 : Tc_Issue_Master_DetailData?.withdraw_date
//                             }
//                             onChange={(e) => {
//                               onChangeHandle(e);
//                             }}
//                             type='date'
//                           />
//                           {errorMessage.withdraw_date && (
//                             <FormText color='danger'>
//                               {errorMessage.withdraw_date}
//                             </FormText>
//                           )}
//                         </td>
//                       </tr>
//                       <tr>
//                         <td>
//                           <h6 for='fee_remark'>Fee Remark</h6>
//                         </td>
//                         <td>
//                           <Input
//                             id='fee_remark'
//                             name='fee_remark'
//                             value={Tc_Issue_Master_DetailData?.fee_remark}
//                             onChange={(e) => {
//                               onChangeHandle(e);
//                             }}
//                           />
//                           {errorMessage.fee_remark && (
//                             <FormText color='danger'>
//                               {errorMessage.fee_remark}
//                             </FormText>
//                           )}
//                         </td>
//                       </tr>
//                     </tbody>
//                   </table>
//                 </Form>
//               </CardBody>
//             </Card>
//           </Col>
//           <Col className='col-sm-5'>
//             {/* <Card className='card-box height-100-p pd-20 mb-20'>
//                       <CardTitle className='border-bottom p-3 mb-0 d-flex align-items-center justify-content-between'
//                       >
//                         <div className='d-flex align-items-center'>
//                           <i className='bi bi-cash-stack mr-2'></i>
//                           Balance Fee Details
//                         </div>
//                       </CardTitle>
//                       <CardBody>
//                         {AdmissionData.id ?

//                           <table className="table table-borderless">
//                             <tbody>
//                               <tr>
//                                 <td>
//                                   <h6>Session Fee</h6>
//                                 </td>
//                                 <td>
//                                   : ₹{feeBalanceDetails?.tot_session_fee}
//                                 </td>
//                               </tr>

//                               <tr>
//                                 <td>
//                                   <h6>Fee Amt Due</h6>
//                                 </td>
//                                 <td>
//                                   : ₹{feeBalanceDetails?.fee_amt_due}
//                                 </td>
//                               </tr>

//                               <tr>
//                                 <td>
//                                   <h6>Fee Paid</h6>
//                                 </td>
//                                 <td>
//                                   : ₹{feeBalanceDetails?.fee_amt_paid}
//                                 </td>
//                               </tr>

//                               <tr>
//                                 <td>
//                                   <h6>Current Month</h6>
//                                 </td>
//                                 <td>
//                                   : {feeBalanceDetails?.current_month_name}
//                                 </td>
//                               </tr>

//                               <tr>
//                                 <td>
//                                   <h6>Current Month Fees</h6>
//                                 </td>
//                                 <td>
//                                   : ₹{feeBalanceDetails?.current_month_fee_amt}

//                                 </td>
//                               </tr>
//                               <tr>
//                                 <td>
//                                   <h6>Slab Name</h6>
//                                 </td>
//                                 <td>
//                                   : {feeBalanceDetails?.slabMasterDetails?.slab_name}

//                                 </td>
//                               </tr>
//                               {/* <tr>
//                                 <td>
//                                   <h6>Current Month Fees</h6>
//                                 </td>
//                                 <td>
//                                   : ₹{feeBalanceDetails.current_month_fee_amt}

//                                 </td>
//                               </tr>
//                             </tbody>
//                           </table>

//                           :
//                           <>
//                             <p className='text-center'>No Details Available</p>
//                             <p className='text-center'>(Please enter a valid admission no. first)</p>
//                           </>

//                         }
//                       </CardBody>
//             </Card> */}

//             <Card className='card-box height-100-p pd-20 mb-20'>
//               <CardTitle className='border-bottom p-3 mb-0 d-flex align-items-center justify-content-between'>
//                 <div className='d-flex align-items-center'>
//                   <i className='bi bi-person-fill mr-2'></i>
//                   Student Details
//                 </div>
//               </CardTitle>
//               <CardBody>
//                 {AdmissionData?.admission?.id ? (
//                   <>
//                     <table className='table table-borderless'>
//                       <tbody>
//                         <tr>
//                           <td>
//                             <h6>Adm. No.</h6>
//                           </td>
//                           <td>: {AdmissionData?.admission?.admit_no}</td>
//                         </tr>

//                         <tr>
//                           <td>
//                             <h6>Name</h6>
//                           </td>
//                           <td>: {AdmissionData?.admission?.stud_name}</td>
//                         </tr>
//                         <tr>
//                           <td>
//                             <h6>Class & Sec</h6>
//                           </td>
//                           <td>
//                             : {AdmissionData?.admission?.curr_class}{' '}
//                             {AdmissionData?.admission?.curr_sec}
//                           </td>
//                         </tr>

//                         <tr>
//                           <td>
//                             <h6>D.O.B</h6>
//                           </td>
//                           <td>: {formatDate(AdmissionData?.admission?.d_o_b)}</td>
//                         </tr>
//                         <tr>
//                           <td>
//                             <h6>Gender</h6>
//                           </td>
//                           <td>: {AdmissionData?.admission?.sex_mf}</td>
//                         </tr>
//                         <tr>
//                           <td>
//                             <h6>Father Name</h6>
//                           </td>
//                           <td>: {AdmissionData?.admission?.f_name}</td>
//                         </tr>
//                         <tr>
//                           <td>
//                             <h6>Mobile no.(F)</h6>
//                           </td>
//                           <td>: {AdmissionData?.admission?.f_mob}</td>
//                         </tr>
//                         <tr>
//                           <td>
//                             <h6>Mother Name</h6>
//                           </td>
//                           <td>: {AdmissionData?.admission?.m_name}</td>
//                         </tr>
//                         <tr>
//                           <td>
//                             <h6>Mobile no.(M)</h6>
//                           </td>
//                           <td>: {AdmissionData?.admission?.m_mob}</td>
//                         </tr>
//                         <tr>
//                           <td>
//                             <h6>Admission Date</h6>
//                           </td>
//                           <td>: {formatDate(AdmissionData?.admission?.adm_date)}</td>
//                         </tr>
//                         {/* <tr>
//         <td />
//         <td>
//           <button type="button" className="btn btn-primary">
//             Edit Contact
//           </button>
//         </td>
//       </tr> */}
//                       </tbody>
//                     </table>
//                   </>
//                 ) : (
//                   <>
//                     <p className='text-center'>No Details Available...</p>
//                     <p className='text-center'>
//                       (Please enter a valid admission no. first)
//                     </p>
//                   </>
//                 )}
//               </CardBody>
//             </Card>
//           </Col>

//           {/* <Col className='col-sm-12'>
//           <div className='card'>
//             <div className='card-body'>
//               <div className='table-responsive'>
//                 <table className='table'>
//                   <thead>
//                     <tr>
//                       <th>Head_Name</th>
//                       <th>Tot_Fee</th>
//                       <th>Paid</th>
//                       <th>Pending</th>
//                       <th>Current</th>
//                       <th>Rec_Amt</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {SlabMasterTotalMont ? (
//                       SlabMasterTotalMont.map((item, index) => {
//                         return (
//                           <>
//                             <tr key={index}>
//                               <td>{item.fee_head_name}</td>
//                               <td>{item.fee_amt}</td>
//                               <td>{item.paid}</td>
//                               <td>{item.pending}</td>
//                               <td>{item.fee_amt}</td>
//                               <td>{item.rec_amt}</td>
//                             </tr>
//                           </>
//                         );
//                       })
//                     ) : (
//                       <tr>no data to show</tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           </div>
//         </Col> */}
//         </Row>
//       </div>

//       <Modal centered isOpen={modal} toggle={toggle}>
//         <ModalHeader toggle={toggle}>
//           Add new {Multi_Purpose_Type_MasterData.multi_purpose_flag}
//         </ModalHeader>
//         <ModalBody>
//           <Form>
//             <div
//               className='accordion accordion-flush'
//               id='accordionFlushExample'
//             >
//               <FormGroup>
//                 <Label for='multi_purpose_type'>
//                   Enter new {Multi_Purpose_Type_MasterData.multi_purpose_flag}{' '}
//                   option detail :
//                 </Label>
//                 <Input
//                   id='multi_purpose_type'
//                   name='multi_purpose_type'
//                   value={Multi_Purpose_Type_MasterData.multi_purpose_type}
//                   onChange={onChangeHandle1}
//                 />
//                 {errorMessage.multi_purpose_type && (
//                   <FormText color='danger'>
//                     {errorMessage.multi_purpose_type}
//                   </FormText>
//                 )}
//               </FormGroup>
//             </div>
//           </Form>
//         </ModalBody>
//         <ModalFooter>
//           <Button
//             className='mt-2'
//             color='primary'
//             onClick={save_multi_purpose_master}
//           >
//             Submit
//           </Button>
//           <Button color='secondary' onClick={toggle}>
//             Cancel
//           </Button>
//         </ModalFooter>
//       </Modal>
//     </>
//   );
// };

// export default TcIssueSaveScreen;
// heena
import React, { useState, useEffect, useRef } from 'react';
import {
  Card,
  Row,
  Col,
  CardTitle,
  CardBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';

import { useNavigate, useLocation } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import { BlobProvider } from '@react-pdf/renderer';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useSelector } from 'react-redux';
import PdfView from './PdfView';
import { formatDate } from '../../constants/DateFormatter';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import useVendorBranch from '../../utils/useVendorBranch';
import conditionalDataLoad from '../../utils/conditionalDataLoad';
import Select from 'react-select';

const TcIssueSaveScreen = ({ systemData }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const sessionData = useSelector((state) => state.sessionState);
  const { user } = useSelector((state) => state.authState || {});
  const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
    useVendorBranch(user);

  // const [selectedClassId, setSelectedClassId] = useState(''); // id string
  const [AdmissionNo, setAdmissionNo] = useState('');
    const [classOptions, setClassOptions] = useState([]);
  const [showFeeSlabDetails, setShowFeeSlabDetails] = useState(false);
  const [AutoCompleteValue, setAutoCompleteValue] = useState(null);
  const [studRecords, setStudRecords] = useState([]);
  const [resultDetailList, setResultDetailList] = useState([]);
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  const [errorMessage, setErrorMessage] = useState({});
  const [feeBalanceDetails, setFeeBalanceDetails] = useState({});
  const [AdmissionData, setAdmissionData] = useState({});

  const [Tc_Issue_Master_DetailData, setTc_Issue_Master_DetailData] = useState({
    id: 0,
    vendor_id: 0,
    branch_id: 0,
    tc_no_manual: '',
    issue_date: new Date()
      .toLocaleDateString('en-CA', { timeZone: 'Asia/Kolkata' })
      .split('T')[0],
    admit_no: '',
    tc_for_current: '',
    tc_for_end: '',
    possible_attend_days: '',
    attendance_days: '',
    leave_taken_days: '',
    result_detail: '',
    promot_yn: '',
    certificate_type: '',
    file_no_1: '',
    file_no_2: '',
    last_attended_date: '',
    withdraw_date: '',
    narr_remark: '',
    session_year: sessionData.session_year,
    sys_remark: '',
    fee_remark: '',
    tc_no_auto_id: 0,
    fee_group_id: 0,
    slabMstId: 0,
    from_year: '',
    to_year: '',
  });

  const [Multi_Purpose_Type_MasterData, setMulti_Purpose_Type_MasterData] =
    useState({
      multi_purpose_flag: '',
      multi_purpose_code: '',
      multi_purpose_type: '',
      multi_purpose_remark: '',
    });

   useEffect(() => {
    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: Tc_Issue_Master_DetailData.vendor_id,
      branchId: Tc_Issue_Master_DetailData.branch_id,
    });
    if (canLoad) {
    fetchClasses();
    }
  }, [
    Tc_Issue_Master_DetailData.vendor_id, 
    Tc_Issue_Master_DetailData.branch_id]);


  const fetchClasses = async (searchText = '') => {
    try {
      const vendorId = Tc_Issue_Master_DetailData.vendor_id || '';
      const branchId = Tc_Issue_Master_DetailData.branch_id || '';
      // if (!vendorId || !branchId) {
      //   setClassOptions([]);
      //   return;
      // }

      const res = await apiService.get(
        `api/ClassMaster/GetClassMaster?vendorId=${vendorId}&branchId=${branchId}&searchItem=${encodeURIComponent(
          searchText || '',
        )}`,
      );

      if (res?.status === true) {
        const raw = res?.data || [];
        const opts = (raw || [])
          .map((x) => ({
            value: String(x.class_Name),
            label: String(
              x.class_display_name ??
                x.class_Name ??
                x.className ??
                x.name ??
                'No Name',
            ),
          }))
          .filter((o) => o.value && o.value !== '0');

        setClassOptions(opts);
      } else {
        setClassOptions([]);
      }
    } catch (err) {
      console.error(err);
      setClassOptions([]);
    }
  };
  // Enrollment style
  const GetAdmission = async (search = '', selectedAdmNo = '') => {
    try {
      const response = await apiService.get(
        `api/Enrollment/GetAllEnrollment?vendorId=${
          Tc_Issue_Master_DetailData.vendor_id || ''
        }&branchId=${
          Tc_Issue_Master_DetailData.branch_id || ''
        }&search=${encodeURIComponent(search || '')}`,
      );

      if (response.response && response.response.data?.errors) {
        alert(response.response.data.errors);
      }

      if (response.status === true) {
        const list = response.data || [];
        setStudRecords(list);

        const admToSelect = selectedAdmNo || search;

        if (admToSelect) {
          const match = list.find(
            (s) => String(s.admit_no || '') === String(admToSelect || ''),
          );

          if (match) {
            setAutoCompleteValue(match);
            setAdmissionData(match);
            setTc_Issue_Master_DetailData((prev) => ({
              ...prev,
              admit_no: match.admit_no || prev.admit_no,
              tc_issue_yn: match.tc_issue_yn || prev.tc_issue_yn,
            }));
            setAdmissionNo(match.admit_no || '');
          }
        }
      } else {
        alert(response.message);
      }
    } catch (error) {
      console.log(error);
      alert('Something went wrong!!');
    }
  };

  useEffect(() => {
    Get_All_Multi_Purpose_Type_Master();
  }, []);

  // preload like enrollment
  // useEffect(() => {
  //   const canLoad = conditionalDataLoad({
  //     hasMultiBranch,
  //     hasSingleBranch,
  //     isSuperAdmin,
  //     isAdmin,
  //     vendorId: Tc_Issue_Master_DetailData.vendor_id,
  //     branchId: Tc_Issue_Master_DetailData.branch_id,
  //   });

  //   if (!canLoad) return;

  //   GetAdmission('', '');
  // }, [
  //   Tc_Issue_Master_DetailData.vendor_id,
  //   Tc_Issue_Master_DetailData.branch_id,
  //   isSuperAdmin,
  //   isAdmin,
  //   hasMultiBranch,
  //   hasSingleBranch,
  // ]);

  useEffect(() => {
    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: Tc_Issue_Master_DetailData.vendor_id,
      branchId: Tc_Issue_Master_DetailData.branch_id,
    });

    if (!canLoad) return;

    if (location.state) {
      setTc_Issue_Master_DetailData((prev) => ({
        ...prev,
        ...location.state,
      }));
      setAdmissionNo(location.state.admit_no || '');
      if (location.state.admit_no) {
        GetAdmission(location.state.admit_no, location.state.admit_no);
      }
    }
  }, [
    location.state,
    Tc_Issue_Master_DetailData.vendor_id,
    Tc_Issue_Master_DetailData.branch_id,
    isSuperAdmin,
    isAdmin,
    hasMultiBranch,
    hasSingleBranch,
  ]);

  useEffect(() => {
    if (
      Tc_Issue_Master_DetailData?.net_amt ===
      feeBalanceDetails?.current_month_fee_amt
    ) {
      setShowFeeSlabDetails(true);
    } else {
      setShowFeeSlabDetails(false);
    }
  }, [Tc_Issue_Master_DetailData, feeBalanceDetails]);

  const onHandleBackParty = () => {
    navigate('/Tc_Issue_Master_Detail_Search_Screen');
  };

  const onInputChange = (event, newInputValue) => {
    if (isSuperAdmin) {
      if (
        !Tc_Issue_Master_DetailData.vendor_id ||
        Number(Tc_Issue_Master_DetailData.vendor_id) <= 0
      ) {
        alert('Please select Vendor');
        return;
      }
    }

    if (isSuperAdmin || isAdmin || hasMultiBranch) {
      if (
        !Tc_Issue_Master_DetailData.branch_id ||
        Number(Tc_Issue_Master_DetailData.branch_id) <= 0
      ) {
        alert('Please select Branch');
        return;
      }
    }

    GetAdmission(newInputValue, newInputValue);

    setTc_Issue_Master_DetailData((prevData) => ({
      ...prevData,
      admit_no: newInputValue,
    }));
  };

  const onChangeHandle = (event) => {
    const { name, value } = event.target;

    if (name === 'possible_attend_days') {
      const total = parseFloat(value) || 0;
      const attend =
        parseFloat(Tc_Issue_Master_DetailData.attendance_days) || 0;
      const leaves = total - attend;

      setTc_Issue_Master_DetailData((prevData) => ({
        ...prevData,
        [name]: String(total),
        attendance_days: String(attend),
        leave_taken_days: String(leaves),
      }));
      return;
    }

    if (name === 'attendance_days') {
      const total =
        parseFloat(Tc_Issue_Master_DetailData.possible_attend_days) || 0;
      const attend = parseFloat(value) || 0;
      const leaves = total - attend;

      setTc_Issue_Master_DetailData((prevData) => ({
        ...prevData,
        possible_attend_days: String(total),
        [name]: String(attend),
        leave_taken_days: String(leaves),
      }));
      return;
    }

    setTc_Issue_Master_DetailData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const onChangeHandle1 = (e) => {
    const { name, value } = e.target;
    setMulti_Purpose_Type_MasterData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    setErrorMessage((prevErrors) => ({
      ...prevErrors,
      [name]: '',
    }));
  };

  const validateInputs1 = () => {
    const errors = {};
    if (!Multi_Purpose_Type_MasterData.multi_purpose_type) {
      errors.multi_purpose_type = 'multi_purpose_type is required';
    }
    return errors;
  };

  const save_multi_purpose_master = async () => {
    try {
      const errors = validateInputs1();
      if (Object.keys(errors).length > 0) {
        setErrorMessage(errors);
        return;
      }

      let config = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };
      const data = JSON.stringify(Multi_Purpose_Type_MasterData);

      let response;

      if (
        Multi_Purpose_Type_MasterData.id === '0' ||
        Multi_Purpose_Type_MasterData.id === 0
      ) {
        response = await apiService.put(
          `api/Multi_Purpose_Type_Master/UpdateMulti_Purpose_Type_Master?id=${Multi_Purpose_Type_MasterData.id}`,
          data,
          config,
        );
      } else {
        response = await apiService.post(
          'api/Multi_Purpose_Type_Master/AddMulti_Purpose_Type_Master',
          data,
          config,
        );
      }
      if (response.status === true) {
        alert(response.message);
        setModal(!modal);
        setMulti_Purpose_Type_MasterData({
          multi_purpose_flag: '',
          multi_purpose_code: '',
          multi_purpose_type: '',
          multi_purpose_remark: '',
        });
        Get_All_Multi_Purpose_Type_Master();
      } else {
        alert(response.message);
      }
    } catch (error) {
      console.log(error);
      alert('Something went wrong"');
    }
  };

  const GetStudentFeeDetails = async (adm_no, month_name, month_no) => {
    const errors = {};
    try {
      if (!month_name) {
        errors.month_name = 'No Month is selected';
        setErrorMessage(errors);
        setAutoCompleteValue(null);
        return;
      }

      if (!month_no) {
        errors.month_no = 'No Month is selected';
        setErrorMessage(errors);
        setAutoCompleteValue(null);
        return;
      }

      const response = await apiService.get(
        `api/FeeReciept/GetStudentFeeDetails?adm_no=${adm_no}&month_name=${month_name}&month_no=${month_no}&session=${sessionData.session_year}`,
      );

      if (response.response && response.response.data.errors) {
        alert(response.response?.data?.errors);
      }

      if (response.status === true) {
        setFeeBalanceDetails(response);
        setAdmissionData(response.studentDetails);
        setStudRecords([response.studentDetails]);
        setAutoCompleteValue(response.studentDetails);
      } else {
        alert(response.message);
      }
    } catch (error) {
      console.log(error);
      alert('SomeThing went wrong');
    }
  };

  const validateInputs = () => {
    const errors = {};

    if (
      isSuperAdmin &&
      (!Tc_Issue_Master_DetailData.vendor_id ||
        Number(Tc_Issue_Master_DetailData.vendor_id) <= 0)
    ) {
      errors.vendor_id = 'Vendor is required';
    }

    if (
      (isSuperAdmin || isAdmin || hasMultiBranch) &&
      (!Tc_Issue_Master_DetailData.branch_id ||
        Number(Tc_Issue_Master_DetailData.branch_id) <= 0)
    ) {
      errors.branch_id = 'Branch is required';
    }

    if (!Tc_Issue_Master_DetailData?.admit_no) {
      errors.admit_no = 'Adm no is required';
    }

    if (!Tc_Issue_Master_DetailData?.from_year) {
      errors.from_year = 'From year is required';
    }
    if (!Tc_Issue_Master_DetailData?.to_year) {
      errors.to_year = 'To year is required';
    }
    if (!Tc_Issue_Master_DetailData?.possible_attend_days) {
      errors.possible_attend_days = 'Possible attended days is required';
    }
    if (!Tc_Issue_Master_DetailData?.leave_taken_days) {
      errors.leave_taken_days = 'Leave taken days is required';
    }
    if (!Tc_Issue_Master_DetailData?.result_detail) {
      errors.result_detail = 'Result detail is required';
    }
    if (!Tc_Issue_Master_DetailData?.promot_yn) {
      errors.promot_yn = 'Promote status is required';
    }
    if (!Tc_Issue_Master_DetailData?.certificate_type) {
      errors.certificate_type = 'Certificate type is required';
    }

    if (!Tc_Issue_Master_DetailData?.last_attended_date) {
      errors.last_attended_date = 'Last attended date is required';
    }
    if (!Tc_Issue_Master_DetailData?.withdraw_date) {
      errors.withdraw_date = 'Withdraw date is required';
    }
    if (!Tc_Issue_Master_DetailData?.sys_remark) {
      errors.sys_remark = 'Remark is required';
    }

    if (!Tc_Issue_Master_DetailData?.fee_remark) {
      errors.fee_remark = 'Fee remark is required';
    }
    return errors;
  };

  const SaveFunction = async () => {
    try {
      const errors = validateInputs();
      if (Object.keys(errors).length > 0) {
        setErrorMessage(errors);
        console.log(errors);
        return;
      }

      const payload = {
        ...Tc_Issue_Master_DetailData,
        enrollment_id : AdmissionData.enrollment_id,
        admit_no: AdmissionNo || Tc_Issue_Master_DetailData.admit_no,
      };

      let config = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };

      let response;

      if (payload?.id === 0) {
        response = await apiService.post(
          'api/TcIssueMasterDetail/AddTc_Issue_Master_Detail',
          payload,
          config,
        );
      } else {
        response = await apiService.put(
          `api/TcIssueMasterDetail/UpdateTc_Issue_Master_Detail?id=${payload?.id}`,
          payload,
          config,
        );
      }

      if (response.status === true) {
        alert(response.message);
        setTc_Issue_Master_DetailData((prev) => ({
          ...prev,
          ...(response.tcIssueMasterDetail || {}),
        }));
      } else {
        alert(response.message);
      }
    } catch (error) {
      console.log(error);
      alert('Something went wrong');
    }
  };

  const onHandleDelete = async () => {
    const isDeleteConfirmed = window.confirm(
      'Are you sure you want to delete this item?',
    );
    if (isDeleteConfirmed) {
      try {
        let config = {
          headers: {
            'Content-Type': 'application/json',
            accept: 'application/json',
          },
        };

        const response = await apiService.delete(
          `api/TcIssueMasterDetail/DeleteTc_Issue_Master_Detail?id=${location.state?.id}`,
          config,
        );

        if (response.response && response.response.data.errors) {
          alert(response.response?.data?.errors);
        }

        if (response.status === true) {
          alert(response.message);
        } else {
          alert(response.message);
        }
      } catch (error) {
        console.log(error);
        alert('Something went wrong');
      }
    } else {
      console.log('Deletion canceled.');
    }
  };

  const CertificateList = [
    { label: '-Select-', value: '' },
    { label: 'Original', value: 'ORIGINAL' },
    { label: 'Duplicate', value: 'DUPLICATE' },
    { label: 'Triplicate', value: 'TRIPLICATE' },
  ];
  const ynList = [
    { label: '-Select-', value: '' },
    { label: 'Yes', value: 'YES' },
    { label: 'No', value: 'NO' },
  ];

  const Get_All_Multi_Purpose_Type_Master = async () => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };
      const response = await apiService.get(
        `api/Multi_Purpose_Type_Master/GetMulti_Purpose_Type_Master?filter=Result_Detail`,
        config,
      );
      if (response.response && response.response.data.errors) {
        alert(response.response?.data?.errors);
      }
      if (response.status === true) {
        setResultDetailList(response.data);
      } else {
        alert(response.message);
      }
    } catch (error) {
      console.log(error);
      alert('SomeThing went wrong!!');
    }
  };

  const onHandleMultipleValue = (param) => {
    setModal(!modal);
    setMulti_Purpose_Type_MasterData((prevData) => ({
      ...prevData,
      multi_purpose_flag: param,
    }));
  };

  return (
    <>
      <div className='container-fluid px-3 px-md-4'>
        <div className='bg-white pd-5 card-box mb-3 toolbar-row sticky-top border text-right'>
          <Button color='success' onClick={SaveFunction}>
            <i className='bi bi-check-circle' /> Save
          </Button>
          &nbsp;
          <Button
            className='btn btn-warning'
            onClick={() => onHandleBackParty()}
          >
            <i className='bi bi-arrow-left' /> Back
          </Button>
          {Tc_Issue_Master_DetailData?.id !== 0 &&
            AdmissionData &&
            Tc_Issue_Master_DetailData &&
            systemData && (
              <>
                &nbsp;
                <BlobProvider
                  document={
                    <PdfView
                      admission_Data={AdmissionData}
                      tc_Issue_Master_Data={Tc_Issue_Master_DetailData}
                      schoolData={systemData}
                    />
                  }
                >
                  {({ url }) => (
                    <button
                      className='btn btn-info'
                      onClick={() => {
                        if (url) {
                          window.open(url, '_blank');
                        }
                      }}
                    >
                      <i className='bi bi-printer' /> Print TC
                    </button>
                  )}
                </BlobProvider>
                &nbsp;
                <Button
                  color='danger'
                  size='bg'
                  onClick={() => onHandleDelete()}
                >
                  Delete
                </Button>
              </>
            )}
        </div>

        <Row className='g-3'>
          <Col xs='12'>
            <VendorBranchSelector
              user={user}
              selectionData={Tc_Issue_Master_DetailData}
              setSelectionData={setTc_Issue_Master_DetailData}
              accessButton={true}
              errorMessage={errorMessage}
            />
          </Col>

          <Col xl='7' lg='7' md='12'>
            <Card className='card-box h-100 pd-20 mb-20'>
              <CardTitle
                tag='h6'
                className='border-bottom p-3 mb-0 d-flex align-items-center justify-content-between'
              >
                <div className='d-flex align-items-center'>
                  <i className='bi bi-card-text mr-2'></i>
                  TC Issue Details
                </div>
              </CardTitle>

              <CardBody className='h-100'>
                <Form>
                  <table className='table table-borderless mb-0'>
                    <tbody>
                      <tr>
                        <td style={{ width: '35%' }}>
                          <h6>Admission No.</h6>
                        </td>
                        <td>
                          <Autocomplete
                            name='admit_no'
                            id='admit_no'
                            options={studRecords}
                            value={AutoCompleteValue}
                            getOptionLabel={(o) => {
    if (!o) return "";

    if (user.working_bussinesss_mode === "SCHOOL") {
      return `${o.admit_no} - ${o.student_name} - ${o?.admission?.f_name || ""}`;
    }

    // default
    return `${o.enrollment_number} - ${o.student_name} - ${o?.stud_ph_no}`;
  }}
                            onChange={(event, newValue) => {
                              if (newValue) {
                                setTc_Issue_Master_DetailData((prevData) => ({
                                  ...prevData,
                                  admit_no: newValue.admit_no,
                                  tc_issue_yn: newValue.admission.tc_issue_yn,
                                }));
                                setAdmissionData(newValue);
                                setAdmissionNo(newValue.admit_no);
                                setAutoCompleteValue(newValue);
                              } else {
                                setAutoCompleteValue(null);
                                setAdmissionData({});
                                setTc_Issue_Master_DetailData((prevData) => ({
                                  ...prevData,
                                  admit_no: '',
                                }));
                              }
                            }}
                            onInputChange={onInputChange}
                            openOnFocus={true}
                            renderInput={(params) => (
                              <TextField
                                sx={{
                                  '& .MuiInputBase-root': {
                                    height: '44px',
                                    fontSize: '15px',
                                    borderRadius: '6px',
                                  },
                                  '& .MuiOutlinedInput-input': {
                                    padding: '10px',
                                  },
                                }}
                                {...params}
                                placeholder='Search Adm.no., Name, Mobile no., etc'
                                variant='outlined'
                              />
                            )}
                          />

                          {errorMessage.admit_no && (
                            <FormText color='danger'>
                              {errorMessage.admit_no}
                            </FormText>
                          )}
                        </td>

                        
                      </tr>

                      <tr>
                        <td>
                          <h6 htmlFor='tc_issue_yn'>TC Issued </h6>
                        </td>
                        <td>
                         <span className={`badge badge-${AdmissionData?.admission?.tc_issue_yn === "NO" ? "danger" : "success"}`}>
                            {AdmissionData?.admission?.tc_issue_yn}
                          </span>
                          {errorMessage.tc_issue_yn && (
                            <FormText color='danger'>
                              {errorMessage.tc_issue_yn}
                            </FormText>
                          )}
                        </td>
                      </tr>

                       <tr>
                        <td>
                          <h6 htmlFor='tc_for_end'>Select the Class</h6>
                        </td>
                        <td>
                      
            <Select
              options={classOptions}
              value={
                classOptions.find(
                  (o) => String(o.value) === String(Tc_Issue_Master_DetailData.curr_class),
                ) || null
              }
              onChange={(opt) =>
                 setTc_Issue_Master_DetailData((prevData) => ({
        ...prevData,
        curr_class: String(opt.value),
      }))
              }
              onInputChange={(val, meta) => {
                if (meta.action === 'input-change') fetchClasses(val);
              }}
              isClearable
              isSearchable
              placeholder='Type a Course Name...'
            />
                          {errorMessage.tc_for_end && (
                            <FormText color='danger'>
                              {errorMessage.tc_for_end}
                            </FormText>
                          )}
                        </td>
                      </tr>


                      <tr>
                        <td>
                          <h6 htmlFor='issue_date'>TC Issue Date</h6>
                        </td>
                        <td>
                          <Input
                            id='issue_date'
                            name='issue_date'
                            value={
                              typeof Tc_Issue_Master_DetailData?.issue_date ===
                                'string' &&
                              Tc_Issue_Master_DetailData?.issue_date.includes(
                                'T',
                              )
                                ? Tc_Issue_Master_DetailData?.issue_date.split(
                                    'T',
                                  )[0]
                                : Tc_Issue_Master_DetailData?.issue_date
                            }
                            onChange={(e) => {
                              onChangeHandle(e);
                            }}
                            type='date'
                          />

                          {errorMessage.issue_date && (
                            <FormText color='danger'>
                              {errorMessage.issue_date}
                            </FormText>
                          )}
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <h6 htmlFor='from_year'>Financial year from</h6>
                        </td>
                        <td>
                          <Input
                            id='from_year'
                            name='from_year'
                            value={Tc_Issue_Master_DetailData?.from_year}
                            onChange={(e) => {
                              onChangeHandle(e);
                            }}
                            type='number'
                          />
                          {errorMessage.from_year && (
                            <FormText color='danger'>
                              {errorMessage.from_year}
                            </FormText>
                          )}
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <h6 htmlFor='to_year'>Financial year To</h6>
                        </td>
                        <td>
                          <Input
                            id='to_year'
                            name='to_year'
                            value={Tc_Issue_Master_DetailData?.to_year}
                            onChange={(e) => {
                              onChangeHandle(e);
                            }}
                          />
                          {errorMessage.to_year && (
                            <FormText color='danger'>
                              {errorMessage.to_year}
                            </FormText>
                          )}
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <h6 htmlFor='file_no_1'>File/Manual No</h6>
                        </td>
                        <td>
                          <Input
                            id='file_no_1'
                            name='file_no_1'
                            value={Tc_Issue_Master_DetailData?.file_no_1}
                            onChange={(e) => {
                              onChangeHandle(e);
                            }}
                          />
                          {errorMessage.file_no_1 && (
                            <FormText color='danger'>
                              {errorMessage.file_no_1}
                            </FormText>
                          )}
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <h6 htmlFor='sys_remark'>Remark</h6>
                        </td>
                        <td>
                          <Input
                            id='sys_remark'
                            name='sys_remark'
                            value={Tc_Issue_Master_DetailData?.sys_remark}
                            onChange={(e) => {
                              onChangeHandle(e);
                            }}
                          />
                          {errorMessage.sys_remark && (
                            <FormText color='danger'>
                              {errorMessage.sys_remark}
                            </FormText>
                          )}
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <h6 htmlFor='certificate_type'>Certificate Type</h6>
                        </td>
                        <td>
                          <select
                            className='custom-select form-control'
                            id='certificate_type'
                            name='certificate_type'
                            value={Tc_Issue_Master_DetailData?.certificate_type}
                            onChange={(e) => {
                              onChangeHandle(e);
                            }}
                          >
                            {CertificateList.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </select>
                          {errorMessage.certificate_type && (
                            <FormText color='danger'>
                              {errorMessage.certificate_type}
                            </FormText>
                          )}
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <h6 htmlFor='tc_for_end'>Tc After End Session</h6>
                        </td>
                        <td>
                          <select
                            className='custom-select form-control'
                            id='tc_for_end'
                            name='tc_for_end'
                            value={Tc_Issue_Master_DetailData?.tc_for_end}
                            onChange={(e) => {
                              onChangeHandle(e);
                            }}
                          >
                            {ynList.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </select>
                          {errorMessage.tc_for_end && (
                            <FormText color='danger'>
                              {errorMessage.tc_for_end}
                            </FormText>
                          )}
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <h6 htmlFor='possible_attend_days'>
                            Possible Attendence
                          </h6>
                        </td>
                        <td>
                          <Input
                            id='possible_attend_days'
                            name='possible_attend_days'
                            value={
                              Tc_Issue_Master_DetailData?.possible_attend_days
                            }
                            onChange={(e) => {
                              onChangeHandle(e);
                            }}
                          />
                          {errorMessage.possible_attend_days && (
                            <FormText color='danger'>
                              {errorMessage.possible_attend_days}
                            </FormText>
                          )}
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <h6 htmlFor='attendance_days'>Actual Attendance</h6>
                        </td>
                        <td>
                          <Input
                            id='attendance_days'
                            name='attendance_days'
                            value={Tc_Issue_Master_DetailData?.attendance_days}
                            onChange={(e) => {
                              onChangeHandle(e);
                            }}
                          />
                          {errorMessage.attendance_days && (
                            <FormText color='danger'>
                              {errorMessage.attendance_days}
                            </FormText>
                          )}
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <h6 htmlFor='leave_taken_days'>Total Leaves Taken</h6>
                        </td>
                        <td>
                          <Input
                            id='leave_taken_days'
                            name='leave_taken_days'
                            value={Tc_Issue_Master_DetailData?.leave_taken_days}
                            onChange={(e) => {
                              onChangeHandle(e);
                            }}
                            readOnly
                          />
                          {errorMessage.leave_taken_days && (
                            <FormText color='danger'>
                              {errorMessage.leave_taken_days}
                            </FormText>
                          )}
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <h6 htmlFor='result_detail'>
                            Result{' '}
                            <i
                              className='bi bi-question-circle float-end text-primary'
                              onClick={() =>
                                onHandleMultipleValue('Result_Detail')
                              }
                            />
                          </h6>
                        </td>
                        <td>
                          <Input
                            id='result_detail'
                            name='result_detail'
                            type='select'
                            className='custom-select'
                            value={Tc_Issue_Master_DetailData?.result_detail}
                            onChange={(e) => {
                              onChangeHandle(e);
                            }}
                          >
                            <option value=''>-Select-</option>
                            {resultDetailList.map((option) => (
                              <option
                                key={option.multi_purpose_type}
                                value={option.multi_purpose_type}
                              >
                                {option.multi_purpose_type}
                              </option>
                            ))}
                          </Input>
                          {errorMessage.result_detail && (
                            <FormText color='danger'>
                              {errorMessage.result_detail}
                            </FormText>
                          )}
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <h6 htmlFor='promot_yn'>Promoted (yes/no)</h6>
                        </td>
                        <td>
                          <select
                            className='custom-select form-control'
                            id='promot_yn'
                            name='promot_yn'
                            value={Tc_Issue_Master_DetailData?.promot_yn}
                            onChange={(e) => {
                              onChangeHandle(e);
                            }}
                          >
                            {ynList.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </select>
                          {errorMessage.promot_yn && (
                            <FormText color='danger'>
                              {errorMessage.promot_yn}
                            </FormText>
                          )}
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <h6 htmlFor='last_attended_date'>
                            Last Attended Date
                          </h6>
                        </td>
                        <td>
                          <Input
                            id='last_attended_date'
                            name='last_attended_date'
                            value={
                              typeof Tc_Issue_Master_DetailData?.last_attended_date ===
                                'string' &&
                              Tc_Issue_Master_DetailData?.last_attended_date.includes(
                                'T',
                              )
                                ? Tc_Issue_Master_DetailData?.last_attended_date.split(
                                    'T',
                                  )[0]
                                : Tc_Issue_Master_DetailData?.last_attended_date
                            }
                            onChange={(e) => {
                              onChangeHandle(e);
                            }}
                            type='date'
                          />
                          {errorMessage.last_attended_date && (
                            <FormText color='danger'>
                              {errorMessage.last_attended_date}
                            </FormText>
                          )}
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <h6 htmlFor='withdraw_date'>Withdrawal Date</h6>
                        </td>
                        <td>
                          <Input
                            id='withdraw_date'
                            name='withdraw_date'
                            value={
                              typeof Tc_Issue_Master_DetailData?.withdraw_date ===
                                'string' &&
                              Tc_Issue_Master_DetailData?.withdraw_date.includes(
                                'T',
                              )
                                ? Tc_Issue_Master_DetailData?.withdraw_date.split(
                                    'T',
                                  )[0]
                                : Tc_Issue_Master_DetailData?.withdraw_date
                            }
                            onChange={(e) => {
                              onChangeHandle(e);
                            }}
                            type='date'
                          />
                          {errorMessage.withdraw_date && (
                            <FormText color='danger'>
                              {errorMessage.withdraw_date}
                            </FormText>
                          )}
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <h6 htmlFor='fee_remark'>Fee Remark</h6>
                        </td>
                        <td>
                          <Input
                            id='fee_remark'
                            name='fee_remark'
                            value={Tc_Issue_Master_DetailData?.fee_remark}
                            onChange={(e) => {
                              onChangeHandle(e);
                            }}
                          />
                          {errorMessage.fee_remark && (
                            <FormText color='danger'>
                              {errorMessage.fee_remark}
                            </FormText>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Form>
              </CardBody>
            </Card>
          </Col>

          <Col xl='5' lg='5' md='12'>
            <Card className='card-box h-100 pd-20 mb-20'>
              <CardTitle className='border-bottom p-3 mb-0 d-flex align-items-center justify-content-between'>
                <div className='d-flex align-items-center'>
                  <i className='bi bi-person-fill mr-2'></i>
                  Student Details
                </div>
              </CardTitle>
              <CardBody>
                {AdmissionData?.admission?.id ? (
                  <>
                    <table className='table table-borderless'>
                      <tbody>
                        <tr>
                          <td>
                            <h6>Adm. No.</h6>
                          </td>
                          <td>: {AdmissionData?.admission?.admit_no}</td>
                        </tr>

                        <tr>
                          <td>
                            <h6>Name</h6>
                          </td>
                          <td>: {AdmissionData?.admission?.stud_name}</td>
                        </tr>

                        <tr>
                          <td>
                            <h6>Class & Sec</h6>
                          </td>
                          <td>
                            : {AdmissionData?.admission?.curr_class}{' '}
                            {AdmissionData?.admission?.curr_sec}
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <h6>D.O.B</h6>
                          </td>
                          <td>: {formatDate(AdmissionData?.admission?.d_o_b)}</td>
                        </tr>

                        <tr>
                          <td>
                            <h6>Gender</h6>
                          </td>
                          <td>: {AdmissionData?.admission?.sex_mf}</td>
                        </tr>

                        <tr>
                          <td>
                            <h6>Father Name</h6>
                          </td>
                          <td>: {AdmissionData?.admission?.f_name}</td>
                        </tr>

                        <tr>
                          <td>
                            <h6>Mobile no.(F)</h6>
                          </td>
                          <td>: {AdmissionData?.admission?.f_mob}</td>
                        </tr>

                        <tr>
                          <td>
                            <h6>Mother Name</h6>
                          </td>
                          <td>: {AdmissionData?.admission?.m_name}</td>
                        </tr>

                        <tr>
                          <td>
                            <h6>Mobile no.(M)</h6>
                          </td>
                          <td>: {AdmissionData?.admission?.m_mob}</td>
                        </tr>

                        <tr>
                          <td>
                            <h6>Admission Date</h6>
                          </td>
                          <td>: {formatDate(AdmissionData?.admission?.adm_date)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </>
                ) : (
                  <>
                    <p className='text-center'>No Details Available...</p>
                    <p className='text-center'>
                      (Please enter a valid admission no. first)
                    </p>
                  </>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Modal centered isOpen={modal} toggle={toggle}>
          <ModalHeader toggle={toggle}>
            Add new {Multi_Purpose_Type_MasterData.multi_purpose_flag}
          </ModalHeader>
          <ModalBody>
            <Form>
              <div
                className='accordion accordion-flush'
                id='accordionFlushExample'
              >
                <FormGroup>
                  <Label htmlFor='multi_purpose_type'>
                    Enter new {Multi_Purpose_Type_MasterData.multi_purpose_flag}{' '}
                    option detail :
                  </Label>
                  <Input
                    id='multi_purpose_type'
                    name='multi_purpose_type'
                    value={Multi_Purpose_Type_MasterData.multi_purpose_type}
                    onChange={onChangeHandle1}
                  />
                  {errorMessage.multi_purpose_type && (
                    <FormText color='danger'>
                      {errorMessage.multi_purpose_type}
                    </FormText>
                  )}
                </FormGroup>
              </div>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button
              className='mt-2'
              color='primary'
              onClick={save_multi_purpose_master}
            >
              Submit
            </Button>
            <Button color='secondary' onClick={toggle}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </>
  );
};

export default TcIssueSaveScreen;